import {
  BrainCircuit,
  Sparkles,
  MessageSquareCode,
  Lightbulb,
  Cpu,
  Wrench,
  Bug,
} from 'lucide-react';
import type { FeatureGroup } from '../types';

export const aiGroup: FeatureGroup = {
  id: 'ai',
  label: 'AI Tools',
  headline: 'AI that speaks OpenSCAD',
  summary:
    'Meshpit integrates AI across the entire workflow — from generating new models from scratch, to modifying and fixing existing code, to explaining unfamiliar patterns. Bring your own API key via OpenRouter.',
  accentClass: 'from-violet-500 to-indigo-400',
  items: [
    {
      icon: BrainCircuit,
      title: 'Create by Prompt',
      description:
        "Describe what you want in plain English and let the AI generate the OpenSCAD code. Review a plan before any code is written, watch it stream in, and iterate until it's right. Works with GPT-4o, Claude, Gemini, and more via OpenRouter.",
      tier: 'major',
    },
    {
      icon: Sparkles,
      title: 'Improve with AI',
      description:
        'Select any block of code and ask the AI to improve, refactor, or extend it. The AI sees the full model context and writes changes that actually compile.',
      tier: 'major',
    },
    {
      icon: MessageSquareCode,
      title: 'Explain Mode',
      description:
        'Select code and get a plain-English explanation — with syntax-highlighted examples, step-by-step breakdowns, and contextual tips. Rendered with full Markdown formatting.',
      tier: 'major',
    },
    {
      icon: Lightbulb,
      title: 'AI Parameter Suggestions',
      description:
        'Let the AI inspect your model and suggest better parameter definitions — improved names, sensible ranges, and the right widget types for each value.',
      tier: 'major',
    },
    {
      icon: Cpu,
      title: 'WebMCP Support',
      description:
        'Meshpit supports the Model Context Protocol (MCP) over WebSockets — connect any MCP-compatible AI agent directly to your open model for programmatic editing.',
      tier: 'major',
    },
    {
      icon: Wrench,
      title: 'Modify with AI',
      description:
        'Open the AI dialog in modify mode with a free-form prompt — targeted edits to existing code without replacing the whole file.',
      tier: 'minor',
    },
    {
      icon: Bug,
      title: 'Fix with AI',
      description:
        'Paste a compile error or use /ai fix and the AI diagnoses and repairs it in one step — no manual debugging needed.',
      tier: 'minor',
    },
  ],
};
